import { gql } from "@apollo/client";

export const MUTATION_CHANGE_PASSWORD = gql`
  mutation changePassword(
    $currentPassword: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    changePassword(
      currentPassword: $currentPassword
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      __typename
    }
  }
`;

export const MUTATION_UPDATE = gql`
  mutation updateUser($id: ID!, $data: UsersPermissionsUserInput!) {
    updateUsersPermissionsUser(id: $id, data: $data) {
      data {
        updatedAt
      }
    }
  }
`;
